// extracted by mini-css-extract-plugin
export default {"variables":"\"../../../../variables.css\"","dark-blue-background":"#175259","medium-768":"min-width: 768px","MenuToggle":"Menu_MenuToggle__w7gkH"};